import { graphql } from 'react-relay';
import type {
	useBlueprintTypeEditorEditorLabelsQuery as useBlueprintTypeEditorEditorLabelsQuery$data,
	useBlueprintTypeEditorEditorLabelsQueryVariables as useBlueprintTypeEditorEditorLabelsQuery$variables,
} from './__types__/useBlueprintTypeEditorEditorLabelsQuery.ts';
import { PREDEFINED_BLUEPRINT_TYPES_TITLES } from './constants.ts';
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';
export const getBlueprintType = (labels: any): any => {
	for (const label of labels) {
		const value = PREDEFINED_BLUEPRINT_TYPES_TITLES[label];
		if (value !== undefined) return label;
	}

	return '';
};

export const getBlueprintFromLabels = (data: any): any => {
	const labels = data?.content?.nodes?.[0]?.labels?.nodes?.map((x) => x.name) ?? [];
	return getBlueprintType(labels);
};

export const useBlueprintType = (contentId: string, skip: boolean = false): any => {
	const { data, loading, error } = useQueryInterop<
		useBlueprintTypeEditorEditorLabelsQuery$data,
		useBlueprintTypeEditorEditorLabelsQuery$variables
	>(
		graphql`
			query useBlueprintTypeEditorEditorLabelsQuery($contentId: ID!) {
				content(id: $contentId) {
					nodes {
						id
						labels {
							nodes {
								id
								name
							}
						}
					}
				}
			}
		`,
		{
			skip,
			variables: { contentId },
		},
	);

	if (loading || error) {
		return '';
	}

	return getBlueprintFromLabels(data);
};
